import React from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'

import NewCount from '../../../molecules/BaseConversation/NewCount'

import { useNotificationCount } from '../../../../providers/NotificationCountProvider'
import useStyles from './styles'

const NavItem = ({
  to,
  children,
  notifications = 0,
  disabled,
  onMove,
  name,
  aliases = [],
  dataTestId
}) => {
  // Gets props from SideNav
  const history = useHistory()

  const active = React.useMemo(() => {
    let path = history.location.pathname

    if (path.endsWith('/') && path !== '/') {
      path = path.substring(0, path.length - 1)
    }

    if (path !== '/') {
      const parts = path.split('/').filter(Boolean)
      path = `/${parts[0]}`
    }

    return !disabled && (to === path || aliases.includes(path))
  }, [history, disabled, to, aliases])

  const classes = useStyles()

  const clickHandler = React.useCallback(() => {
    if (!disabled) {
      onMove && onMove()
      history.push(to)
    }
  }, [disabled, onMove, history, to])

  return (
    <div
      onClick={clickHandler}
      data-testid={dataTestId}
      className={clsx(classes.root, active && classes.rootActive)}
    >
      <div className={clsx(classes.icon, active && classes.iconActive)}>
        {children}

        {notifications > 0 && (
          <NewCount count={notifications} className={classes.dot} />
        )}
      </div>

      <div className={clsx(classes.title, active && classes.titleActive)}>
        {name}
      </div>
    </div>
  )
}

export default NavItem

export const DashboardNavItem = props => {
  const { dashboardNotifs } = useNotificationCount()

  return <NavItem {...props} notifications={dashboardNotifs} />
}

export const PeerChatItem = props => {
  const { peerNotifs } = useNotificationCount()

  return <NavItem {...props} notifications={peerNotifs} />
}
